// src/components/Footer.js
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/footer.css";

const Footer = () => {
    const [data, setData] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancel = false;
        (async () => {
            try {
                const r = await fetch("/data/footer.json", { cache: "no-store" });
                if (!r.ok) throw new Error("HTTP " + r.status);
                const json = await r.json();
                if (!cancel) setData(json);
            } catch (e) {
                console.error("[Footer] Error cargando /data/footer.json:", e);
                if (!cancel) setError(true);
            } finally {
                if (!cancel) setCargando(false);
            }
        })();
        return () => { cancel = true; };
    }, []);

    if (cargando || !data) {
        return <footer aria-busy="true" style={{ minHeight: 80 }} />;
    }

    if (error) {
        return <footer><p role="alert">{data.ui?.loadError}</p></footer>;
    }

    const year = new Date().getFullYear();

    return (
        <footer>
            <div className="footer-contenido">
                {/* Columna 1: Logo + texto + redes */}
                <div className="footer-col info-general">
                    <img
                        src={data.brand.logo}
                        alt={data.brand.logoAlt}
                        className="logo-extenso"
                    />
                    <p>{data.brand.text}</p>
                    <div className="redes-sociales">
                        {data.socials.map((s, i) => (
                            <a key={i} href={s.href} target="_blank" rel="noopener noreferrer">
                                <img src={s.icon} alt={s.alt} />
                            </a>
                        ))}
                    </div>
                </div>

                {/* Columna 2: Navegación */}
                <div className="footer-col navegacion">
                    <h1>{data.nav.title}</h1>
                    <ul>
                        {data.nav.links.map((l, i) => (
                            <li key={i}>
                                <Link to={l.to}>{l.label}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Columna 3: Horario + contacto */}
                <div className="footer-col horario">
                    <h1>{data.schedule.title}</h1>
                    {data.schedule.rows.map((row, i) => (
                        <div key={i} className="fila-horario">
                            <span className="dia">{row.day}</span>
                            <span className="hora">{row.hour}</span>
                        </div>
                    ))}

                    {data.contact.map((c, i) => (
                        <div key={i} className="info-item">
                            <img src={c.icon} alt={c.alt} />
                            <p dangerouslySetInnerHTML={{ __html: c.text }} />
                        </div>
                    ))}
                </div>
            </div>

            <div className="footer-final">
                <p>
                    &copy; {year} {data.footer.text}{" "}
                    <a href={data.footer.author.href} target="_blank" rel="noopener noreferrer">
                        {data.footer.author.label}
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
